/* Moved out of snippets/bf-fixes.liquid (Oct 16, 2026) so it no longer sits inline in <head>.
   Oct 29 2026 (TEST theme only): sticky bar always adds; explicit size pick required; inline name error. */
/* 6. Bottom buy bar on phones.
   The theme shows the bar only after the shopper scrolls past the main button. This shows it from the
   start as well, while the main button is still below the screen. On a product with options the bar
   first reads "Choose ..." and takes the shopper to the options, so nobody adds a color or size they
   never saw. Once most of the options have been on screen, or one is picked, the bar adds to the bag
   as usual. The add itself is the theme's own: the bar presses the main Add to cart button. */
(function () {
  var BAR = 'sticky-add-to-cart .sticky-add-to-cart__bar';

  /* One tap, one add. This runs on every screen size and is set up before the theme's own scripts.
     The bar's button works by pressing the main Add to cart button, so a tap is let through only when
     the main button can take it:
     - not while the theme is still loading a newly picked option (the main button is switched off for
       that moment, and the bar would show its tick without adding anything);
     - not while a required field, such as the name on the personalized cup, is empty (the shopper is
       shown the field instead);
     - not within a second and a half of the last tap. */
  var lastAdd = 0;
  document.addEventListener('click', function (event) {
    var target = event.target;
    var btn = target && target.closest ? target.closest('.sticky-add-to-cart__button') : null;
    if (!btn) return;
    if (btn.closest('.sticky-add-to-cart__bar[data-bf-choose]')) return;
    var main = document.querySelector('.buy-buttons-block [ref="addToCartButton"]');
    var form = main ? main.closest('form') : null;
    var busy = !!main && main.disabled;
    var incomplete = !busy && !!form && !form.noValidate && typeof form.checkValidity === 'function' && !form.checkValidity();
    var now = Date.now();
    if (busy || incomplete || now - lastAdd < 1500) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (incomplete && typeof form.reportValidity === 'function') form.reportValidity();
      return;
    }
    lastAdd = now;
    /* The theme's tick is cleared by a header icon this store's header does not have. Clear it here. */
    window.setTimeout(function () { btn.removeAttribute('data-added'); }, 2000);
  }, true);

  function init() {
    if (!window.matchMedia('(max-width:749px)').matches) return;
    var block = document.querySelector('.buy-buttons-block');
    if (!document.querySelector(BAR) || !block || !('IntersectionObserver' in window)) return;
    var picker = document.querySelector('variant-picker');
    var footer = document.querySelector('footer');
    var multi = !!picker && picker.querySelectorAll('input[type=radio],select option').length > 1;
    var seen = false;
    var choosing = false;

    function chooseLabel() {
      var groups = picker.querySelectorAll('fieldset legend,.variant-option--dropdowns label');
      if (groups.length === 1) {
        var first = groups[0].childNodes[0];
        var name = ((first && first.textContent) || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (name && name.length <= 10) return 'Choose ' + name;
      }
      return groups.length > 1 ? 'Choose options' : 'Choose option';
    }
    function startChoose() {
      var bar = document.querySelector(BAR);
      var btn = bar && bar.querySelector('.sticky-add-to-cart__button');
      if (choosing || !btn || btn.disabled) return;
      choosing = true;
      var text = chooseLabel();
      /* Keep the bar the same height in both states so the swap causes no layout shift. */
      var bh = bar.offsetHeight; if (bh) bar.style.height = bh + 'px';
      bar.setAttribute('data-bf-choose', '');
      btn.setAttribute('data-bf-label', text);
      btn.setAttribute('aria-label', text);
      if (btn.hasAttribute('on:click')) {
        btn.setAttribute('data-bf-on', btn.getAttribute('on:click'));
        btn.removeAttribute('on:click');
      }
    }
    function endChoose() {
      if (!choosing) return;
      choosing = false;
      var bar = document.querySelector(BAR);
      if (!bar) return;
      bar.removeAttribute('data-bf-choose');
      bar.style.height = '';
      var btn = bar.querySelector('.sticky-add-to-cart__button');
      if (!btn) return;
      btn.removeAttribute('data-bf-label');
      btn.removeAttribute('aria-label');
      if (btn.hasAttribute('data-bf-on')) {
        btn.setAttribute('on:click', btn.getAttribute('data-bf-on'));
        btn.removeAttribute('data-bf-on');
      }
    }
    function setStuck(value) {
      var bar = document.querySelector(BAR);
      if (bar && bar.dataset.stuck !== value) bar.dataset.stuck = value;
    }

    /* One place decides what the bar does, from where things are on the screen right now:
       - hidden while the main button or the footer is on screen (the theme hides it at the same
         two moments, but only if the theme itself showed it, which a bar shown from the start is not);
       - "Choose ..." until most of the options have been on screen above the bar, or the shopper has
         scrolled past the main button;
       - otherwise the normal add button. */
    function update() {
      var height = window.innerHeight;
      var rect = block.getBoundingClientRect();
      var blockOnScreen = rect.bottom > 0 && rect.top < height;
      if (blockOnScreen || rect.bottom <= 0) seen = true;
      if (!seen && picker) {
        var options = picker.getBoundingClientRect();
        var shown = Math.min(options.bottom, height - 80) - Math.max(options.top, 0);
        if (shown > 0 && (shown >= options.height * 0.6 || shown >= height * 0.5)) seen = true;
      }
      if (seen) endChoose();
      var foot = footer ? footer.getBoundingClientRect() : null;
      var footerOnScreen = !!foot && foot.top < height && foot.bottom > 0;
      if (blockOnScreen || footerOnScreen) {
        setStuck('false');
      } else {
        /* Oct 29 2026 (TEST): no more "Choose options" step. The bar is always a real Add to cart;
           if a size has not been picked yet, the size check below shows the prompt instead of adding. */
        setStuck('true');
      }
    }

    var observer = new IntersectionObserver(update, { threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] });
    observer.observe(block);
    if (picker) observer.observe(picker);
    if (footer) observer.observe(footer);
    update();

    /* A jump down the page (a link, a fast flick) can skip the moments the checks above wait for. */
    var timer = 0;
    window.addEventListener('scroll', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(update, 150);
    }, { passive: true });

    /* Picking an option counts as having seen the options. */
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('variant-picker')) {
        seen = true;
        endChoose();
      }
    }, true);

    /* While the bar reads "Choose ...", a tap takes the shopper to the options and adds nothing. */
    document.addEventListener('click', function (event) {
      if (!choosing || !event.target || !event.target.closest) return;
      if (!event.target.closest('.sticky-add-to-cart__bar[data-bf-choose]')) return;
      event.preventDefault();
      event.stopPropagation();
      /* A second tap that lands just as the bar turns back into an add button is not an add. */
      lastAdd = Date.now() - 800;
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var target = document.querySelector('variant-picker') || block;
      target.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
      var first = target.querySelector ? target.querySelector('input:checked,input,select') : null;
      if (first && first.focus) first.focus({ preventScroll: true });
    }, true);

    /* Turning the phone on its side can take it out of phone layout. The bar is then a plain add button. */
    var phone = window.matchMedia('(max-width:749px)');
    if (phone.addEventListener) {
      phone.addEventListener('change', function () {
        if (!phone.matches) { seen = true; endChoose(); }
      });
    }

    /* After an option change the theme redraws the product section. Keep watching the right element. */
    document.addEventListener('variant:update', function () {
      /* An option changed, however it was changed: the "Choose" step is over. */
      seen = true;
      endChoose();
      window.requestAnimationFrame(function () {
        var fresh = document.querySelector('.buy-buttons-block');
        if (fresh && fresh !== block) {
          observer.unobserve(block);
          block = fresh;
          observer.observe(block);
        }
        update();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* 7. Oct 29 2026 (TEST theme only). Pick a size on purpose.
   The theme opens a product with the first colour and the SMALLEST size already selected, and Add to cart
   (main button, bottom bar, Buy with Shop / Apple Pay) would add that size without the shopper ever choosing it.
   Now every size option with more than one value starts as "not picked": its pills show no selection, a
   "Pick a size" prompt sits under it, and any add or express-checkout tap shows a visible inline message and
   scrolls to the size instead of adding. One tap on any size (including the one already selected) counts as a
   pick. A link that names a variant (?variant=) counts as picked. Colour stays preselected (it is shown in the photos). */
(function () {
  var picked = {};
  var fromLink = /[?&]variant=\d+/.test(location.search);
  function nameOf(fs) {
    var lg = fs.querySelector('legend');
    var t = lg && lg.childNodes[0] ? lg.childNodes[0].textContent : '';
    return (t || '').replace(/\s+/g, ' ').trim();
  }
  function sizeSets() {
    var out = [];
    document.querySelectorAll('variant-picker fieldset.variant-option').forEach(function (fs) {
      var n = nameOf(fs);
      if (/size/i.test(n) && fs.querySelectorAll('input[type=radio]').length > 1) out.push(fs);
    });
    return out;
  }
  function missing() {
    if (fromLink) return [];
    return sizeSets().filter(function (fs) { return !picked[nameOf(fs)]; });
  }
  /* Nov 3, 2026 (TEST 189709386031, CRO): with one size picker say 'a size' (was 'the kid size' on baby items). */
  function label(fs) { var n = nameOf(fs); return (/^size$/i.test(n) || sizeSets().length < 2) ? 'a size' : 'the ' + n.toLowerCase(); }
  function paint() {
    var sets = sizeSets();
    sets.forEach(function (fs) {
      var need = !fromLink && !picked[nameOf(fs)];
      fs.classList.toggle('bf-size-unpicked', need);
      var p = fs.querySelector('.bf-size-prompt');
      if (need && !p) {
        p = document.createElement('p');
        p.className = 'bf-size-prompt';
        p.setAttribute('aria-live', 'polite');
        p.textContent = 'Pick ' + label(fs) + ' to continue.';
        fs.appendChild(p);
      } else if (!need && p) { p.remove(); }
    });
    var left = missing();
    document.documentElement.classList.toggle('bf-size-needed', left.length > 0);
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (bar) bar.setAttribute('data-bf-pick', left.length ? ('Pick ' + label(left[0])) : '');
    var ve = bar && bar.querySelector('.sticky-add-to-cart__variant');
    if (ve) ve.setAttribute('data-bf-pick-text', left.length ? ('Pick ' + label(left[0])) : '');
  }
  function warn(list) {
    list.forEach(function (fs) {
      var p = fs.querySelector('.bf-size-prompt');
      if (p) { p.classList.add('bf-size-prompt--error'); p.setAttribute('role', 'alert'); p.textContent = 'Please pick ' + label(fs) + ' first.'; }
    });
    var first = list[0];
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    first.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
    var r = first.querySelector('input[type=radio]');
    if (r && r.focus) r.focus({ preventScroll: true });
  }
  function guard(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var isAdd = e.type === 'submit' ? !!t.closest('form[data-type="add-to-cart-form"]')
      : !!t.closest('[ref="addToCartButton"], .sticky-add-to-cart__button, .bf-mm-sticky button, shopify-accelerated-checkout, .shopify-payment-button, [data-shopify="payment-button"]');
    if (!isAdd) return;
    var left = missing();
    if (!left.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    warn(left);
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
  /* Any tap on a size pill, even the one already selected, is a pick. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var fs = t && t.closest ? t.closest('variant-picker fieldset.variant-option') : null;
    if (!fs || !t.closest('label, input')) return;
    var n = nameOf(fs);
    if (/size/i.test(n)) { picked[n] = true; window.setTimeout(paint, 0); }
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    var fs = t && t.closest ? t.closest('variant-picker fieldset.variant-option') : null;
    if (fs && /size/i.test(nameOf(fs))) {
      // Oct 30, 2026: an automatic move off a hidden sold-out size (e.bfAuto) asks the shopper to pick again.
      if (e.bfAuto) { picked[nameOf(fs)] = false; fromLink = false; } else { picked[nameOf(fs)] = true; }
      window.setTimeout(paint, 0);
    }
  }, true);
  /* The theme redraws the product section after an option change. */
  document.addEventListener('variant:update', function () {
    window.requestAnimationFrame(function () { window.requestAnimationFrame(paint); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
})();

/* 8. Oct 29 2026 (TEST theme only). Name sweater: a visible inline message instead of the browser's bubble.
   The name field already sits directly above Add to cart. When it is empty (or has invalid characters) and the
   shopper taps Add to cart, show the reason under the field in text, mark it invalid, and focus it. */
(function () {
  function msgFor(i) {
    var w = i.closest('[data-bf-name-wrap]');
    var m = w && w.querySelector('.bf-name-error');
    if (w && !m) {
      m = document.createElement('p');
      m.className = 'bf-name-error';
      m.id = (i.id || 'BfName') + '-error';
      m.setAttribute('role', 'alert');
      w.insertBefore(m, i.nextSibling);
    }
    return m;
  }
  document.addEventListener('invalid', function (e) {
    var i = e.target;
    if (!i || !i.matches || !i.matches('[data-bf-name-input]')) return;
    e.preventDefault();
    var m = msgFor(i);
    if (m) {
      m.textContent = i.validationMessage || 'Enter the name to embroider.';
      i.setAttribute('aria-invalid', 'true');
      i.setAttribute('aria-describedby', m.id + ' ' + (i.getAttribute('aria-describedby') || '').replace(m.id, '').trim());
    }
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    i.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
    i.focus({ preventScroll: true });
  }, true);
  document.addEventListener('input', function (e) {
    var i = e.target;
    if (!i || !i.matches || !i.matches('[data-bf-name-input]')) return;
    var w = i.closest('[data-bf-name-wrap]');
    var m = w && w.querySelector('.bf-name-error');
    if (m && i.checkValidity()) { m.textContent = ''; i.removeAttribute('aria-invalid'); }
  });
  /* The bottom bar used reportValidity(), which only shows the bubble; make it show the inline message too. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.sticky-add-to-cart__button, [ref="addToCartButton"]')) return;
    var i = document.querySelector('[data-bf-name-input]');
    if (i && !i.disabled && !i.checkValidity()) i.dispatchEvent(new Event('invalid', { cancelable: true }));
  }, true);
})();

/* 9. Oct 29 2026 (TEST theme only). Small additions on top of sections 7 and 8.
   a) The bottom bar's button shows its own label as text next to the bag icon ("Add to cart"), not only the icon.
   b) When a size is still missing, any add tap goes to the size first. This runs on window, before the
      document-level checks above, so the empty-name check can no longer jump past the size prompt.
   c) The name sweater says near the top that a name is needed. */
(function () {
  var HINT = 'Add the name to embroider below before adding to cart.';
  var ADD = '[ref="addToCartButton"], .sticky-add-to-cart__button, .bf-mm-sticky button, shopify-accelerated-checkout, .shopify-payment-button, [data-shopify="payment-button"]';
  function nameOf(fs) {
    var lg = fs.querySelector('legend');
    var t = lg && lg.childNodes[0] ? lg.childNodes[0].textContent : '';
    return (t || '').replace(/\s+/g, ' ').trim();
  }
  function style() {
    if (document.getElementById('bf-fix9-style')) return;
    var s = document.createElement('style');
    s.id = 'bf-fix9-style';
    s.textContent = 'html body .sticky-add-to-cart__bar .sticky-add-to-cart__button[data-bf-text]{width:auto!important;min-width:52px!important;padding-inline:16px!important;gap:6px;border-radius:26px!important}' +
      '.sticky-add-to-cart__bar:not([data-bf-choose]) .sticky-add-to-cart__button[data-bf-text]::after{content:attr(data-bf-text);font-size:14px;font-weight:500;letter-spacing:.02em;white-space:nowrap}' +
      '.bf-name-top-hint{margin:6px 0 0;font-size:14px;line-height:1.45;color:#4a3034}';
    document.head.appendChild(s);
  }
  function paint() {
    style();
    /* Oct 31 2026 (TEST "TEST PDP price line + ATC 2026-10-31"): while no size is picked, the bar's button says
       "Choose size" (not "Add to cart"); a tap scrolls to the size buttons (handled below and in section 7). */
    var needSize = document.documentElement.classList.contains('bf-size-needed');
    document.querySelectorAll('.sticky-add-to-cart__button').forEach(function (b) {
      var t = needSize ? 'Choose size' : (b.getAttribute('aria-label') || '');
      if (t) b.setAttribute('data-bf-text', t); else b.removeAttribute('data-bf-text');
      b.classList.toggle('bf-choose-size', needSize);
    });
    var i = document.querySelector('[data-bf-name-input]');
    var h = document.querySelector('.bf-name-top-hint');
    if (!i) { if (h) h.remove(); return; }
    if (!h) {
      var price = document.querySelector('.product-details product-price') || document.querySelector('product-price');
      if (!price) return;
      h = document.createElement('p');
      h.className = 'bf-name-top-hint';
      h.textContent = HINT;
      price.insertAdjacentElement('afterend', h);
    }
    h.hidden = !!i.disabled;
  }
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest(ADD)) return;
    var left = Array.prototype.slice.call(document.querySelectorAll('variant-picker fieldset.bf-size-unpicked'));
    if (!left.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    left.forEach(function (fs) {
      var p = fs.querySelector('.bf-size-prompt');
      var n = nameOf(fs);
      if (p) { p.classList.add('bf-size-prompt--error'); p.setAttribute('role', 'alert'); p.textContent = 'Please pick ' + (/^size$/i.test(n) ? 'a size' : 'the ' + n.toLowerCase()) + ' first.'; }
    });
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    left[0].scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
    var r = left[0].querySelector('input[type=radio]');
    if (r && r.focus) r.focus({ preventScroll: true });
  }, true);
  document.addEventListener('variant:update', function () {
    window.requestAnimationFrame(function () { window.requestAnimationFrame(paint); });
  });
  /* Oct 31 2026: repaint the bar label when section 7 marks a size as picked or missing. */
  if ('MutationObserver' in window) {
    new MutationObserver(function () { paint(); }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
})();

/* Nov 1 2026 (TEST theme only): phone sticky bar shows the Black Friday checkout price.
   Copies the amount the page already shows in the "[price] at checkout" line (blocks/bf-checkout-price),
   so it only appears where that line appears (never on excluded Mama & Mini sets) and follows size/color changes. */
(function () {
  if (window.__bfStickyCp) return; window.__bfStickyCp = 1;
  var queued = false;
  function sync() {
    queued = false;
    var box = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__price');
    if (!box) return;
    var line = document.querySelector('[data-bf-checkout-price]');
    var src = line && !line.hidden ? line.querySelector('[data-bf-cp-amount]') : null;
    var amt = src ? (src.textContent || '').trim() : '';
    var el = box.querySelector('.bf-sticky-cp');
    if (!amt) { if (el) el.remove(); return; }
    var txt = amt + ' at checkout';
    if (!el) {
      el = document.createElement('div');
      el.className = 'bf-sticky-cp';
      el.style.cssText = 'font-size:12px;line-height:1.25;font-weight:600;color:#8a3b4f;white-space:nowrap;margin-top:2px';
      box.appendChild(el);
    }
    if (el.textContent !== txt) el.textContent = txt;
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(sync); } }
  function start() {
    sync();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
